<template>
  <div
    class="hover:border-indigo-500 border-2 cursor-pointer"
    @click="openDetail"
  >
    <img :src="clip.thumbnail_url" />
  </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    props: {
        clip: {
            type: Object,
            required: true
        }
    },
    methods: {
        openDetail() {
            this.$emit("open-detail", this.clip);
        }
    }
};
</script>